<template>
  <v-container
    fill-height
    fluid
    class="background"
    style="max-height: 100vh;">
    <v-layout
      align-center
      justify-center>
      <v-flex
        xs12
        sm8
        md4>
        <v-card class="elevation-12">
          <v-toolbar color="heron_toolbar">
            <v-avatar
              color="tranparent"
              size="70">
              <img src="../assets/img/energy-control.png" >
            </v-avatar>
            <v-toolbar-title
              class="toolbar_text--text"
            >Energy Control</v-toolbar-title
            >
            <v-spacer />
            <img
              src="../assets/img/heron_icon.svg"
              width="70" >
          </v-toolbar>
          <p
            align="center"
            class="title font-weight-bold">
            Project User Registration
          </p>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="firstname"
                :error-messages="firstnameErrors"
                label="Firstname"
                required
                @input="$v.firstname.$touch()"
                @blur="$v.firstname.$touch()"
              />
              <v-text-field
                v-model="lastname"
                :error-messages="lastnameErrors"
                label="Lastname"
                required
                @input="$v.lastname.$touch()"
                @blur="$v.lastname.$touch()"
              />
              <v-text-field
                v-model="email"
                :error-messages="emailErrors"
                label="E-mail"
                required
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
              />
              <v-text-field
                v-model="password"
                :error-messages="passwordErrors"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPassword ? 'text' : 'password'"
                label="Password"
                required
                @input="$v.password.$touch()"
                @blur="$v.password.$touch()"
                @click:append="showPassword = !showPassword"
              />
              <v-text-field
                v-model="phone"
                :error-messages="phoneErrors"
                label="Phone"
                required
                @input="$v.phone.$touch()"
                @blur="$v.phone.$touch()"
              />
              <v-text-field
                v-model="affiliation"
                :error-messages="affiliationErrors"
                label="Affiliation"
                required
                @input="$v.affiliation.$touch()"
                @blur="$v.affiliation.$touch()"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              block
              color="heron_info"
              @click="clear">
              clear
            </v-btn>
            <v-btn
              block
              color="heron_success"
              @click="register">
              register
            </v-btn>
          </v-card-actions>
          <v-snackbar
            v-model="snackbar"
            :timeout="5000"
            :color="snackColor"
            :top="true"
          >
            {{ errorMessages }}
            <v-btn
              dark
              flat
              @click="snackbar = false">
              Close
            </v-btn>
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],

  validations: {
    firstname: { required },
    lastname: { required },
    phone: { required },
    affiliation: { required },
    email: { required, email },
    password: { required, minLength: minLength(6) },
    checkbox: {
      checked (val) {
        return val
      }
    }
  },

  data: () => ({
    firstname: '',
    lastname: '',
    email: '',
    password: '',
    phone: '',
    affiliation: '',
    checkbox: false,
    showPassword: false,
    errorMessages: '',
    snackbar: false,
    snackColor: '',
    color: 'general',
    checkboxError: false,
    emailError: false,
    passwordError: false,
    firstnameError: false,
    lastnameError: false,
    phoneError: false,
    affiliationError: false
  }),

  computed: {
    firstnameErrors () {
      const errors = []
      if (!this.$v.firstname.$dirty) return errors
      !this.$v.firstname.required && errors.push('First name is required')
      this.firstnameError = errors.length != 0
      return errors
    },
    lastnameErrors () {
      const errors = []
      if (!this.$v.lastname.$dirty) return errors
      !this.$v.lastname.required && errors.push('Last name is required')
      this.lastnameError = errors.length != 0
      return errors
    },
    checkboxErrors () {
      const errors = []
      if (!this.$v.checkbox.$dirty) return errors
      !this.$v.checkbox.checked && errors.push('You must agree to continue!')
      this.checkboxError = errors.length != 0
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid e-mail')
      !this.$v.email.required && errors.push('E-mail is required')
      this.emailError = errors.length != 0
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.minLength &&
        errors.push('Password must be at least 6 characters')
      !this.$v.password.required && errors.push('Password is required')
      this.passwordError = errors.length != 0
      return errors
    },

    phoneErrors () {
      const errors = []
      if (!this.$v.phone.$dirty) return errors
      !this.$v.phone.required && errors.push('Phone is required')
      this.phoneError = errors.length != 0
      return errors
    },
    affiliationErrors () {
      const errors = []
      if (!this.$v.affiliation.$dirty) return errors
      !this.$v.affiliation.required && errors.push('Affiliation is required')
      this.affiliationError = errors.length != 0
      return errors
    }
  },

  methods: {
    register () {
      this.$v.$touch()
      if (
        this.email == '' ||
        this.password == '' ||
        this.firstname == '' ||
        this.lastname == '' ||
        this.phone == '' ||
        this.affiliation == ''
      ) {
        this.requiredInline()
      } else if (
        !this.checkboxError &&
        !this.passwordError &&
        !this.emailError &&
        !this.firstnameError &&
        !this.lastnameError &&
        !this.phoneError &&
        !this.affiliationError
      ) {
        let firstname = this.firstname
        let lastname = this.lastname
        let email = this.email
        let password = this.password
        let phone = this.phone
        let affiliation = this.affiliation
        this.$store
          .dispatch('signup', {
            firstname,
            lastname,
            email,
            password,
            phone,
            affiliation
          })
          .then((response) => {
            // this.signUpOkInline();
            // this.clear();
            setTimeout(() => {
              //   this.$router.push("/register_success");
              this.$router.push({
                name: 'register_success',
                params: {
                  data: {
                    email,
                    route: 'project_user'
                  }
                }
              })
            }, 1000)
          })
          .catch((err) => {
            if (err == 409) {
              this.userExistsErrorInline()
            } else {
              this.apiErrorInline()
            }
          })
      }
    },

    clear () {
      this.$v.$reset()
      this.firstname = ''
      this.lastname = ''
      this.email = ''
      this.password = ''
      this.phone = ''
      this.affiliation = ''
      this.address = ''
      this.supplynumber = ''
      this.kwhprice = ''
      this.checkbox = false
    },
    requiredInline () {
      this.snackbar = true
      this.snackColor = 'error'
      this.errorMessages = 'Please fill all required fields'
    },
    termsAndConditionsInline () {
      this.snackbar = true
      this.snackColor = 'error'
      this.errorMessages = 'Terms and conditions checkbox must be checked'
    },
    apiErrorInline () {
      this.snackbar = true
      this.snackColor = 'error'
      this.errorMessages = 'There was an error executing the request'
    },
    userExistsErrorInline () {
      this.snackbar = true
      this.snackColor = 'error'
      this.errorMessages = 'User already exists'
    }
  },
  metaInfo () {
    return {
      title: 'HERON Energy Control'
    }
  }
}
</script>

<style scoped>
.background {
  background: url("../assets/img/heron_background_new.jpg");
  background-size: cover;
  width: 100%;
  height: 100%;
}
.v-toolbar__title {
  font-size: 1.5rem !important;
}
</style>
